import PhotoSwipeGallerySlide from "./PhotoSwipeGallerySlide.js";
import PhotoSwipe from "../../photoswipe/photoswipe";
import PhotoSwipeUIDefault from "../../photoswipe/photoswipe-ui-default.js";
import Polyfill from "./Polyfill";
import Overlay from "./Overlay";
import SlideShow from "./SlideShow";

const PSWP_CONTROLS_MAIN_ELEMENT_CLASS = 'pswp';
const PSW_CONTROLS_SLIDESHOW_BUTTON_ELEMENT_CLASS = 'pswp__button--playpause';
const PSW_HIDE_CLASS = 'pswp_hide';

const PSWP_CONTROLS = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
	    	<div class="pswp__bg"></div>
	    	<div class="pswp__scroll-wrap">
	        <div class="pswp__container">
	            <div class="pswp__item"></div>
	            <div class="pswp__item"></div>
	            <div class="pswp__item"></div>
	        </div>
	        <div class="pswp__ui pswp__ui--hidden">
	            <div class="pswp__top-bar">
	                <div class="pswp__counter"></div>
	                <button class="pswp__button pswp__button--close" title="{{CLOSE}}"></button>
	                <button class="pswp__button pswp__button--share" title="{{SHARE}}"></button>
	                <button class="pswp__button pswp__button--add2cart" title="{{BUY}}"></button>
	                <button class="pswp__button pswp__button--fs" title="{{FULLSCREEN}}"></button>
	                <button class="pswp__button pswp__button--playpause pswp_hide" data-title-pause="{{PAUSESLIDESHOW}}" data-title-play="{{PLAYSLIDESHOW}}" title="{{PLAYSLIDESHOW}}"></button>
	                <button class="pswp__button pswp__button--zoom" title="{{ZOOM}}"></button>
	                <div class="pswp__preloader">
	                    <div class="pswp__preloader__icn">
	                      <div class="pswp__preloader__cut">
	                        <div class="pswp__preloader__donut"></div>
	                      </div>
	                    </div>
	                </div>
	            </div>
	            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
	                <div class="pswp__share-tooltip"></div> 
	            </div>
	            <button class="pswp__button pswp__button--arrow--left" title="{{PREVIOUS}}">
	            </button>
	            <button class="pswp__button pswp__button--arrow--right" title="{{NEXT}}">
	            </button>
	            <div class="pswp__caption">
	                <div class="pswp__caption__center"></div>
	            </div>
	          </div>
	        </div>
		</div>`;

export default class PhotoSwipeGallery {

    constructor() {
        this._isOpen = false;
        this._gallery = null;
    }

    /**
     * Finds all thumbnail containers on the page
     * @returns {NodeListOf<Element>}
     */
    static getThumbnailContainers() {
        let thumbnailContainer = document.querySelectorAll( 'a[data-eg-lightbox]' );

        // don't add images from the clone slides. They are not clickable but will add duplicates to the lightbox => #818
        return Array.from(thumbnailContainer).filter((tc => {
            return !tc.parentNode.classList.contains('glide__slide--clone');
        }))
    }

    static translate(input) {
        let result = input;

        if (window.EventGalleryLightboxConfiguration) {
            result = result.replace('{{CLOSE}}', EventGalleryLightboxConfiguration.KEY_CLOSE);
            result = result.replace('{{SHARE}}', EventGalleryLightboxConfiguration.KEY_SHARE);
            result = result.replace('{{BUY}}', EventGalleryLightboxConfiguration.KEY_BUY);
            result = result.replace('{{ZOOM}}', EventGalleryLightboxConfiguration.KEY_ZOOM);
            result = result.replace('{{PREVIOUS}}', EventGalleryLightboxConfiguration.KEY_PREVIOUS);
            result = result.replace('{{NEXT}}', EventGalleryLightboxConfiguration.KEY_NEXT);
            result = result.replace('{{FULLSCREEN}}', EventGalleryLightboxConfiguration.KEY_FULLSCREEN);
            result = result.replace('{{PLAYSLIDESHOW}}', EventGalleryLightboxConfiguration.KEY_PLAYSLIDESHOW);
            result = result.replace('{{PAUSESLIDESHOW}}', EventGalleryLightboxConfiguration.KEY_PAUSESLIDESHOW);
        }
        return result;
    }

    /**
     * append the photoswipe controls to the body element. If there is already a control element, we delete it.
     */
    static appendControlls() {
        let controllElements = document.getElementsByClassName(PSWP_CONTROLS_MAIN_ELEMENT_CLASS);
        for(let i=0;i<controllElements.length; i++) {
            Polyfill.removeHtmlElementNode(controllElements[i]);
        }
        let div = document.createElement('div');
        div.innerHTML = PhotoSwipeGallery.translate(PSWP_CONTROLS);
        document.getElementsByTagName('body')[0].appendChild(div);
    }

    static closest(el, fn) {
        return el && ( fn(el) ? el : PhotoSwipeGallery.closest(el.parentNode, fn) );
    };

    static parseHash() {
        return PhotoSwipeGallery._parseHashString(window.location.hash.substring(1));
    }

    /**
     * splits a hash value into its elements. returns an empty object if there is nothing in
     */
    static _parseHashString(hash) {
        let params = {};

        if(hash.length < 5) {
            return params;
        }

        let vars = hash.split('&');
        for (let i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            let pair = vars[i].split('=');
            if(pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        return params;
    };

    /**
     *
     * @param thumbnailContainer Node
     * @returns PhotoSwipeGallerySlide
     */
    static parseThumbnailElement(thumbnailContainer) {
        let item,
            imgEl,
            height,
            width,
            pid,
            gid;

        // include only element nodes
        if(thumbnailContainer.nodeType !== 1) {
            return null;
        }

        imgEl = thumbnailContainer.getElementsByTagName('IMG')[0];

        if (imgEl === undefined) {
            return null;
        }

        height = thumbnailContainer.getAttribute('data-height');
        width = thumbnailContainer.getAttribute('data-width');
        pid = thumbnailContainer.getAttribute('data-pid');
        gid = thumbnailContainer.getAttribute('data-gid');

        if (height === null || width === null || pid === null) {
            return null;
        }

        // create slide object
        item = new PhotoSwipeGallerySlide();
        item.src = thumbnailContainer.getAttribute('href');
        item.w = parseInt(width, 10);
        item.h = parseInt(height, 10);

        item.title = decodeURIComponent(thumbnailContainer.getAttribute('data-title'));

        item.pid = parseInt(pid, 10);

        item.gid = gid;

        item.thumbnailContainer = thumbnailContainer; // save link to element for getThumbBoundsFn

        return item;
    };



    /**
     * searches the galleries for a thumbnail container and returns the
     * Slide object
     *
     * @param thumbnailContainer
     * @returns PhotoSwipeGallerySlide
     */
    getSlideBy(thumbnailContainer) {
        let galleries = this.getGalleries();

        for(let gallery of galleries.values()) {
            for (let i = 0, l = gallery.length; i < l; i++) {
                if (gallery[i].thumbnailContainer === thumbnailContainer) {
                    return gallery[i];
                }
            }
        }

        return null;
    }


    /**
     *
     * @param slide PhotoSwipeGallerySlide
     * @returns {*|number}
     */
    getIndexOfSlide(slide) {
        let slides = this.getGalleries().get(slide.gid);
        return slides.map(function(e) { return e.hash(); }).indexOf(slide.hash());
    }

    /**
     * Parses all elements on the page so we know which triggers for a lightbox exist.
     * Returns a mal containing the gallery and all elements
     * @returns {Map<String, Array>}
     */
    getGalleries() {
        let galleries = new Map(),
            thumbnails = PhotoSwipeGallery.getThumbnailContainers();

        for(let i=0; i<thumbnails.length; i++) {
            let thumbnailContainer = thumbnails[i];
            let gallery;

            let item = PhotoSwipeGallery.parseThumbnailElement(thumbnailContainer);
            if (item !== null) {
                if (galleries.get(item.gid) === undefined) {
                    galleries.set(item.gid, []);
                }
                gallery = galleries.get(item.gid);
                gallery.push(item);
                galleries.set(item.gid, gallery);
            }
        }

        return galleries;
    }

    onThumbnailsClick(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        let eTarget = e.target || e.srcElement;

        // leave the icons for cart&sharing alone
        let iconContainer = PhotoSwipeGallery.closest(eTarget, function(el) {
            return (el.classList && el.classList.contains('eventgallery-icon-container'));
        });
        if (iconContainer !== null) {
            return;
        }

        // find root element of slide
        let clickedListItem = PhotoSwipeGallery.closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'A');
        });

        if(!clickedListItem) {
            return;
        }

        let slide = this.getSlideBy(clickedListItem);
        let index = this.getIndexOfSlide(slide);
        let slides = this.getGalleries().get(slide.gid);

        if(index >= 0) {
            // open PhotoSwipe if valid index found
            this.openPhotoSwipe( index, slides );
        }
        return false;
    };

    /**
     *
     * @param index
     * @param slides
     * @param disableAnimation
     * @param fromURL
     */
    openPhotoSwipe(index, slides, disableAnimation, fromURL) {
        let pswpElement = document.querySelectorAll('.pswp')[0],
            options;

        if (slides === undefined || slides.length === 0 ) {
            return;
        }

        // define options (if needed)
        options = {
            galleryPIDs:true,

            // define gallery index (for URL)
            galleryUID: slides[0].gid,

            shareEl: slides[0].thumbnailContainer ? slides[0].thumbnailContainer.getElementsByClassName('social-share-button').length>0 : false,

            add2cartEl: slides[0].thumbnailContainer ? slides[0].thumbnailContainer.getElementsByClassName('eventgallery-add2cart').length>0 : false,

            getThumbBoundsFn: disableAnimation? null: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                let slide = slides[index],
                    thumbnail = slide.thumbnailContainer.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                let w = rect.width,
                    h = rect.height,
                    x,
                    y,
                    ratio = slide.w/slide.h;

                if (slide.h > slide.w) {
                    x = rect.left;
                    y = rect.top - Math.ceil( ((w / ratio)-h) / 2) + pageYScroll;
                } else {
                    x = rect.left - Math.ceil( ((h * ratio)-w) / 2  );
                    y = rect.top + pageYScroll;
                    w = Math.ceil(h * ratio);
                }
                return {x, y, w};
            },
            overlayClass : Overlay



        };

        // disable close gestures to avoid trouble with the add2cart dialog.
        options.pinchToClose = !options.add2cartEl;
        options.closeOnVerticalDrag = !options.add2cartEl;
        options.closeOnScroll = !options.add2cartEl;

        if (window.EventGalleryLightboxConfiguration) {
            if (parseInt(window.EventGalleryLightboxConfiguration.navigationFadeDelay) > 0) {
                options.timeToIdle = parseInt(window.EventGalleryLightboxConfiguration.navigationFadeDelay);
                options.timeToIdleOutside = parseInt(window.EventGalleryLightboxConfiguration.navigationFadeDelay);
            }
        }

        // PhotoSwipe opened from URL
        if(fromURL) {
            if(options.galleryPIDs) {
                index = parseInt(index, 10);
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(let j = 0; j < slides.length; j++) {
                    if(slides[j].pid === index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if( isNaN(options.index) ) {
            return;
        }

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        this._gallery = new PhotoSwipe( pswpElement, PhotoSwipeUIDefault, slides, options);
        this._gallery.init();

        this.initSlideShow();

        this._isOpen = true;
        this._gallery.listen('close', () => {
            return this._isOpen = false;
        });

        this._gallery.listen('afterChange', () => {
            document.dispatchEvent(Polyfill.createNewEvent('eventgallery-lightbox-changed'));
        });

        document.dispatchEvent(Polyfill.createNewEvent('eventgallery-lightbox-opened'));
    };

    initPhotoSwipe() {
        PhotoSwipeGallery.appendControlls();

        this._registerClickEvents();

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        let hashData = PhotoSwipeGallery.parseHash();
        if(hashData.pid && hashData.gid) {
            this.openPhotoSwipe( hashData.pid ,  this.getGalleries().get(hashData.gid), true, true );
        }
    };

    _registerClickEvents() {
        // loop through all gallery elements and bind events
        let galleries = this.getGalleries();

        for(let gallery of galleries.values()) {
            for (let i = 0, l = gallery.length; i < l; i++) {
                gallery[i].thumbnailContainer.onclick = (e) => {this.onThumbnailsClick(e)};
            }
        }
    }

    /**
     * grabs the current slide from the lightbox
     * @returns PhotoSwipeGallerySlide
     */
    getCurrentSlide() {
        return this._gallery.currItem;
    }

    /**
     * Returns the index if the current item in the lightbox
     *
     * @returns {int}
     */
    getCurrentIndex() {
        return this._gallery.getCurrentIndex();
    }

    /**
     * reinitiate the lightbox. Register the click events for existing and new elements.
     */
    reload() {
        this._registerClickEvents();
    }

    /**
     * reports back if the lightbox is currently open
     * @returns {boolean}
     */
    isOpen() {
        return this._isOpen;
    }

    /**
     *
     * @param afterChangeFunction
     */
    setAfterChangeEventListener(afterChangeFunction) {
        this._gallery.listen('afterChange', afterChangeFunction);
    }

    /**
     * jump to a specific slide.
     * @param index
     */
    gotoSlide(index) {
        this._gallery.goTo(index);
    }

    /**
     * Adds a slide to the slide deck of the current _gallery
     * @param slide PhotoSwipeGallerySlide
     */
    pushSlide(slide) {
        this._gallery.items.push(slide);
    }

    /**
     * removes a slide from the slide deck of the current _gallery
     * @returns {PhotoSwipeGallerySlide}
     */
    popSlide() {
        return this._gallery.items.pop();
    }

    /**
     * reloads a slide after a modification
     */
    reloadSlide() {
        this._gallery.invalidateCurrItems();
        this._gallery.updateSize(true);
    }

    /**
     * switch to the next slide
     */
    nextSlide() {
        this._gallery.next();
    }

    /**
     * Fire up the slide show stuff
     */
    initSlideShow() {
        if (!window.EventGalleryLightboxConfiguration) {
            return;
        }

        if (!window.EventGalleryLightboxConfiguration.doUseSlideshow) {

            return;
        }

        document.getElementsByClassName(PSW_CONTROLS_SLIDESHOW_BUTTON_ELEMENT_CLASS)[0].classList.remove(PSW_HIDE_CLASS);

        let slideShow = new SlideShow(this);
        slideShow.setDelay(window.EventGalleryLightboxConfiguration.slideshowSpeed);

        if (window.EventGalleryLightboxConfiguration.doUseAutoplay) {
            slideShow.toggleSlideShowState();
        }
    }

    /**
     * make the listen function of PhotoSwipe available
     *
     * @param eventName
     * @param fn
     */
    listen(eventName, fn) {
        this._gallery.listen(eventName, fn);
    }


}



/* override handling of Esc key to stop slideshow on first esc (note Esc to leave fullscreen never gets here) */

/*$(document).keydown(function(e) {
    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;
    if ((e.key === "Escape" || e.which == 27 ) && !!lightBox) {
        if (e.preventDefault)  e.preventDefault();
        else  e.returnValue = false;
        if (ssRunning) {
            setSlideshowState(ssButtonClass, false);
        } else {
            lightBox.close();
        }
    }
});
*/
